module.exports = __webpack_public_path__ + "img/5_102.a05a05ee.png";